import React from 'react'

export default function CustomerCreditAccountFooterStyle() {
  return (
    <React.Fragment>
      <style jsx='true'>
      {`
        .action-buttons-container {
          padding: 5px;
          display: flex;
          justify-content: flex-end;
        }
      `}
      </style>
    </React.Fragment>
  )
}
